
<template>
  <!--会员详情-->
  <div class="advanced-form">
    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of baseInfo" :key="index" :span="8">
              <a-form-item class="value-indent" :label="item.label">
                <div class="pic-box absolute" v-if="item.key==='avatar_url_desc'">
                  <img :src="item.value" alt="">
                </div>
                <span v-else class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-form>

    <div class="card">
      <div class="card-head">
        <h3>住房信息</h3>
      </div>
      <div class="card-body">
        <x-tabula
          :searchList="[]"
          rowKey="householder_info_id"
          :columns="columns"
          :listApi="listApi"
          :rowSelection="false"
        >
        </x-tabula>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'memberDetail',
  data () {
    return {
      listApi: {
        url: ``,
        resHandle: '',
        searchHandle: ''
      },

      baseInfo: [
        {key: 'nick_name', label: '昵称', value: ''},
        {key: 'mobile_phone', label: '手机号', value: ''},
        {key: 'avatar_url_desc', label: '头像', value: ''},
        {key: 'sex', label: '性别', value: ''},
        {key: 'birthday', label: '出生年月', value: ''},
        {key: '', label: '', value: ''}, // 填充
        {key: 'from_mode', label: '注册来源', value: ''},
        {key: 'from_os', label: '注册平台', value: ''},
        {key: '', label: '', value: ''}, // 填充
        {key: 'create_time', label: '注册时间', value: ''},
        {key: 'post_ip', label: '注册IP', value: ''},
        {key: 'is_bind_weixin', label: '微信绑定', value: ''},
        {key: 'last_login_time', label: '最后登录时间', value: ''},
        {key: 'last_login_ip', label: '最后登录IP', value: ''},
        {key: 'login_nums', label: '登录次数', value: ''}
      ],
      columns: [
        { title: '所在城市', dataIndex: 'area', align: 'left', width: '' },
        { title: '小区', dataIndex: 'community_name', align: 'left', width: '' },
        { title: '房间', dataIndex: 'room_address', align: 'left', width: '' },
        { title: '住户类型', dataIndex: 'household_type', align: 'left', width: '' },
        { title: '到期时间', dataIndex: 'expire_time', align: 'left', width: '' }
      ],
      tableData: []
    };
  },
  created () {
    this.listApi.url = `/member/rooms/${this.$route.query.id}`;
    this.getDetail();
  },
  mounted () {
  },
  methods: {
    getDetail () {
      this.$get({
        url: `/member/${this.$route.query.id}`,
        params: {}
      }).then(({data}) => {
        for (let item in data) {
          this.baseInfo.forEach((el) => {
            if (el.key === item) {
              el.value = data[item];
            }
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/member/memberInfo/memberDetail.vue